exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".socials li[data-v-060e1729]{display:inline-block}.socials li i[data-v-060e1729]{font-size:35px;margin-right:10px!important}.bkDetails .btn1[data-v-060e1729]{color:#fff;background:#3969bd;border-radius:0;padding:5px 25px;font-size:12px}.bkDetails .btn2[data-v-060e1729]{color:#000;background:#fbf000;border-radius:0;padding:5px 25px;margin-top:10px}.bkImage img[data-v-060e1729]{max-width:230px!important}.bkImage .btn[data-v-060e1729]{border-radius:0;background:#000!important;margin:0 auto;margin-top:10px;padding:5px 25px;display:block}table[data-v-060e1729]{font-size:12px;font-weight:700}@media (max-width:576px){.bkImage img[data-v-060e1729]{margin:0 auto;display:block}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-060e1729","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/overall_layouts/newsitem.vue
// module id = 646
// module chunks = 0